<template>
	<div class="main-menu navbar navbar-expand-lg p-2 p-md-0">
		<button
			class="navbar-toggler"
			type="button"
			data-toggle="collapse"
			data-target="#navbarSupportedContent"
			aria-controls="navbarSupportedContent"
			aria-expanded="false"
			aria-label="Toggle navigation"
		>
			<i class="fas fa-bars"></i>
		</button>
		<div id="navbarSupportedContent" class="collapse navbar-collapse">
			<MainMenu />
		</div>
	</div>
</template>

<script>
import MainMenu from './MainMenu.vue';

export default {
	name: 'HeaderMenu',
	components: {
		MainMenu,
	},
};
</script>

<style lang="scss">
ul.header-nav {
	margin: 0px -16px;
	li {
		a {
			display: inline-block;
			color: rgba(0, 0, 0, 0.54);
			line-height: 24px;
			margin: 0 4px;
			text-transform: uppercase;

			&.active {
				font-weight: bold;
			}
		}
	}
}

.navbar {
	padding: 0px !important;
}
</style>
